import { ReactNode, useEffect } from 'react'
import usePersistedNavigation from '@/hooks/usePersistedNavigation'
import { useNavigationValidation } from '@/hooks/useNavigationValidation'
import { ROUTES } from '@/config/routes'

interface ProtectedFormRouteProps {
  children: ReactNode
  path: string
}

export const ProtectedFormRoute = ({ children, path }: ProtectedFormRouteProps) => {
  const navigate = usePersistedNavigation()
  const { validateNavigation } = useNavigationValidation()
  const isDebugMode = localStorage.getItem('debug') === 'true'
  
  // Skip validation if debug mode is enabled
  const canAccess = isDebugMode || validateNavigation(path)

  useEffect(() => {
    if (!canAccess) {
      console.log('Can not directly access this route, redirecting to first step')

      // Determine the first step in the form flow
      const firstStep = path.includes('/personal/') 
        ? ROUTES.PERSONAL.ROOT.path 
        : ROUTES.BUSINESS.ROOT.path

      // Redirect to the first step if validation fails
      navigate(firstStep)
    }
  }, [canAccess, path, navigate])

  if (!canAccess) {
    return null
  }

  return <>{children}</>
} 